/**
 * Shared manual-play run recorder: tick list + leaderboard payload.
 * Upload goes to the gateway DB proxy (POST /api/runs), never to a GM.
 * The server decides who the run belongs to and whether it is verified;
 * the payload carries neither.
 */

export const MANUAL_SOURCE = 'manual';
export const DEFAULT_HISTORY_CAP = 4000;

export function toLeaderboardScore(value) {
    const n = Number(value);
    if (!Number.isFinite(n)) return 0;
    return Math.round(n);
}

export function createManualRecorder({ maxTicks = DEFAULT_HISTORY_CAP } = {}) {
    return {
        ticks: [],
        meta: {},
        finalized: false,
        inFlight: false,
        maxTicks,
        reset(meta = {}) {
            this.ticks = [];
            this.meta = meta && typeof meta === 'object' ? { ...meta } : {};
            this.finalized = false;
            this.inFlight = false;
        },
        recordTick(tick) {
            if (this.finalized) return;
            if (this.ticks.length >= this.maxTicks) return;
            this.ticks.push(tick);
        },
        buildPayload({ gameId, score, extra, copyToMoveHistory, username } = {}) {
            const history = this.ticks.slice();
            const payload = {
                game_id: gameId,
                score: toLeaderboardScore(score),
                source: MANUAL_SOURCE,
                history,
                ...this.meta,
                ...(extra && typeof extra === 'object' ? extra : {}),
            };
            if (copyToMoveHistory) payload.move_history = history;
            if (username) payload.username = username;
            return payload;
        },
    };
}

export function buildManualRunPayload({
    gameId,
    history = [],
    score,
    extra,
    copyToMoveHistory = false,
    username,
    meta = {},
} = {}) {
    const rec = createManualRecorder();
    rec.meta = meta && typeof meta === 'object' ? { ...meta } : {};
    rec.ticks = Array.isArray(history) ? history.slice() : [];
    return rec.buildPayload({ gameId, score, extra, copyToMoveHistory, username });
}
